module.exports = __webpack_public_path__ + "assets/233f13c81cbdcfab49ebf70d230df183.mp4";